(function () {
    'use strict';

    angular
        .module('recommendationEditModule')
        .controller('RecommendationEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'grcActionPlanService', 'grcRecommendationService', 'grcObservationService', 'historyCtxtService', 'recommendation', 'actionPlans', 'lookupAttributes'];

    function Controller($scope, $state, grcActionPlanService, grcRecommendationService, grcObservationService, historyCtxtService, recommendation, actionPlans, recomLookupAttributes) {

        $scope.recommendation = recommendation;
        $scope.actionPlans = actionPlans;
        $scope.recomLookupAttributes = recomLookupAttributes;

        initPermissions();

        // Recommendations
        $scope.getRecommendation = function () {
            return grcRecommendationService.getRecommendation(recommendation.RecommendationID);
        };

        // Action Plans
        $scope.getActionPlans = function () {
            return grcActionPlanService.getActionPlansByRecommendation($scope.recommendation.RecommendationID);
        };

        // Add Action Plan
        $scope.addActionPlan = function () {
            $state.go('recommendation.edit.actionPlan.add', {
                RecommendationID: recommendation.RecommendationID
            });
        };

        // Go To Action Plan
        $scope.goToActionPlan = function (item) {
            $state.go('recommendation.edit.actionPlan.edit', {
                RecommendationID: recommendation.RecommendationID,
                ActionPlanID: item.ActionPlanID
            });
        };

        // Back To List
        $scope.backToList = function () {
            /*
                Redirection after the Recommendation is deleted
                As the UI doesn't allow to link a Recom to more than one Observation at the moment, redirecting to the first
                Observation of the Recom is acceptable. Also the person who has the Feature Role to delete a Recom also has
                the Feature Role to view the Observation in that BU.
             */
            if ($scope.recommendation.RecomObservations && $scope.recommendation.RecomObservations.length > 0) {
                $state.go('observation.edit', {
                    ObservationID: $scope.recommendation.RecomObservations[0].ObservationID
                });
            } else {
                $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID });
            }
        };

        // State
        $scope.goToCurrentState = function () {
            $state.go('.');
        };

        function initPermissions() {
            $scope.boxModelPermission = $scope.recommendation;
            $scope.boxPermissionKey = 'Recommendation';
            $scope.boxClickablePermission = 'ViewActionPlans';
        }
    }
})();